// src/utils/mobilepay.ts — MobilePay-lippaan maksulinkki
//
// MobilePayn QR-osoite on kirjainkoon suhteen tarkka: .../box/<uuid>/pay-in
// toimii, .../BOX/<UUID>/PAY-IN palauttaa "Sorry, we couldn't find this page".
// WANHAT-klubin linkit olivat tallentuneet kokonaan isoilla kirjaimilla, ja
// sovellus antoi ne MobilePaylle sellaisenaan, joten maksunappi ei toiminut
// (12.10.2026). Siksi linkki rakennetaan aina lippaan UUID:sta uudelleen.

const UUID_IN = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/i;

/**
 * Toimiva maksulinkki klubin tallentamasta arvosta, tai null.
 * Kelpaa pelkkä lippaan UUID tai mikä tahansa linkki, jossa se on.
 * Muu http-linkki palautetaan sellaisenaan.
 */
export function mobilePayLink(code: string | undefined | null): string | null {
  const c = (code || "").trim();
  if (!c) return null;
  const isHttp = c.toLowerCase().startsWith("http");
  const uuid = c.match(UUID_IN)?.[0];
  if (uuid && (!isHttp || /mobilepay\.fi/i.test(c))) {
    return `https://qr.mobilepay.fi/box/${uuid.toLowerCase()}/pay-in`;
  }
  return isHttp ? c : null;
}

/** Tallennusmuoto: MobilePay-linkki kanonisena, muu arvo trimmattuna. */
export function normalizeLipas(value: string): string {
  const v = value.trim();
  return mobilePayLink(v) ?? v;
}
